import { Component, OnInit } from '@angular/core';
import { BuildConfigsService } from './build-configs.service';
import { BuildConfig } from '../model/build-config';
import { Router } from '@angular/router';
import { JiraProject } from '../model/jira-project';
import { GitlabInstance } from '../model/gitlab-instance';
import { forkJoin } from 'rxjs';
import { GitlabService } from '../gitlab/gitlab.service';
import { JiraService } from './jira.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormUtil } from '../shared/util/form-util';
import { Application, ApplicationValues } from '../model/application';

@Component({
  selector: 'app-build-configs',
  templateUrl: './build-configs.component.html',
  styleUrls: ['./build-configs.component.css']
})
export class BuildConfigsComponent implements OnInit {

  configs: BuildConfig[];


  newBuildConfig: boolean = false;
  formBuildConfig: FormGroup;
  readonly isValid = FormUtil.isValid;
  jiraProjects: JiraProject[] | null = null;
  gitlabInstances: GitlabInstance[] | null = null;
  applications: Application[] = ApplicationValues.sort();

  constructor(
    private buildConfigService: BuildConfigsService,
    private gitlabService: GitlabService,
    private jiraService: JiraService,
    private router: Router,
    private fb: FormBuilder) {

    this.formBuildConfig = this.fb.group({
      customer: [null, Validators.required],
      application: ['', Validators.required],
      gitlabInstance: [null, Validators.required],
      gitRepository: ['', Validators.required],
      jiraProject: [null, Validators.required],
      jiraCustomerLabel: ['', Validators.required],
      releaseNotesEmail: ['', FormUtil.commaSepEmail]
    });
  }

  ngOnInit() {

    this.buildConfigService.getConfigs().subscribe(
      configs => this.configs = configs
    );
  }


  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift(
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'fal fa-plus',
          onClick: this.addBuildConfig.bind(this)
        },
      });
  }


  onRowDoubleClick(e) {
    // the row data is in e.data
    this.router.navigate(['/build-configs', e.data.id]);
  }


  getJiraDisplayText(data: JiraProject): string {
    if (!data) {
      return '';
    }

    return `${data.name} (${data.url})`;
  }

  addBuildConfig() {
    if (this.newBuildConfig) {
      return;
    }

    forkJoin([this.gitlabService.getInstances(), this.jiraService.getProjects()])
      .subscribe(results => {
        this.gitlabInstances = results[0];
        this.jiraProjects = results[1];
        this.newBuildConfig = true;
      });
  }

  saveBuildConfig() {
    let value = this.formBuildConfig.value;

    let config = {
      name: value.customer,
      application: value.application,
      jiraId: value.jiraProject.id,
      gitlabId: value.gitlabInstance.id,
      gitRepository: value.gitRepository,
      jiraCustomerLabel: value.jiraCustomerLabel,
      releaseNotesEmail: value.releaseNotesEmail
    } as BuildConfig;

    this.buildConfigService.save(config).subscribe(config => {
      this.configs.push(config);
      this.newBuildConfig = false;
    });
  }
}
